export const createAction = <T extends string, P = void>(type: T, payload: P) => ({ type, payload });

export const createClearAction = <T extends string>(type: T, payload?: unknown) => ({ type, payload });

export default createAction;
